import React from "react";
import { BsSearch } from "react-icons/bs";

function TableFilter({ HandleSearchInputChange, placeholder }) {
  return (
    <div className="absolute top-4 z-10 left-[30%] w-4/12">
      <div className="relative w-full">
        <BsSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          id="search"
          type="text"
          name="filter"
          placeholder={placeholder}
          onChange={(e) => HandleSearchInputChange(e)}
          className="w-full h-10 pl-10 pr-4 bg-white border border-slate-200 rounded-xl outline-none placeholder:text-slate-400 text-slate-800
            focus:ring-2 focus:ring-secondMainColor/20 focus:border-secondMainColor transition-all shadow-sm"
        />
      </div>
    </div>
  );
}

export default TableFilter;
